import UploadImage from "../../assets/icons/UploadImage";

type ImageUploadWithPreviewProps = {
    additionalClassName?: string;
    label: string;
    valueBase64: string;
    value: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    placeholder: string;
}

export const ImageUploadWithPreview = ({ valueBase64, value, onChange, label, additionalClassName, placeholder }: ImageUploadWithPreviewProps) => {

    const renderPoster = () => {
        if (valueBase64?.length || value?.length) {
            return (
                <img
                    alt="upload-preview"
                    src={valueBase64 || value}
                    className="w-full h-full object-contain"
                />
            )
        } else {
            return (
                <div className="flex flex-row items-center">
                    <UploadImage additionalStyle="text-valley-main" />
                    <span className="ml-2 text-[15px] font-semibold leading-[18px] text-valley-main">
                        {placeholder}
                    </span>
                </div>
            )
        }
    }

    return (
        <div className={`flex flex-col ${additionalClassName}`}>
            <p className="admin-form-label mb-2">
                {label}
            </p>
            <div className="flex flex-col">
                <label className={`flex flex-col rounded-lg border border-dashed border-valley-blue h-[114px] justify-center items-center cursor-pointer`}>
                    <input hidden type="file" name="org-logo" accept="image/jpeg,image/png" onChange={onChange} />
                    {renderPoster()}
                </label>
                <span className="mt-0.5 font-medium text-xs text-valley-light-gray">
                    JPG, PNG, SVG
                </span>
                <span className="font-medium text-xs text-valley-light-gray">
                    Не более 600x600px, 5MB
                </span>
            </div>
        </div>
    )
}